import Subtitle from "./Subtitle";
import Title from "./Title";
import SocialFrame from "./svg/SocialFrame";
import SocialXFrame from "./svg/SocialXFrame";
import asciihand from '../assets/images/ASCII/Group 174.png';
import AsciiArt from "./AsciiArt";
import BigEllipse from "./svg/ellipse/BigEllipse";
import DiscordSocial from "./svg/DiscordSocial";
import InstagramSocial from "./svg/InstagramSocial";
import WarpcastSocial from "./svg/WarpcastSocial";
import FarcasterLogo from "./svg/FarcasterLogo";
import GithubIcon from "./svg/GithubIcon";
import TelegramSocial from "./svg/TelegramSocial";
import DotEffect from "./svg/DotEffect";
import SocialChannel1 from "./svg/SocialChannel1";
import SocialChannel2 from "./svg/SocialChannel2";
import SocialChannel3 from "./svg/SocialChannel3";
import SocialChannel4 from "./svg/SocialChannel4";

function FollowUs({ ref0 }: any) {
  return (
    <div ref={ref0} className="w-full xl:w-[1200px] flex flex-col gap-[10px] items-center pb-[130px] relative z-40 mb-[300px] md:mb-40 xl:mb-0">
      <Subtitle>
        // For the community
      </Subtitle>
      <Title>
        Our Socials
      </Title>
      <div className="relative h-[450px] w-full">
        <div className="absolute top-[450px] xl:top-[110px] left-1/2 md:left-[40px] xl:left-[0px] -translate-x-1/2 md:translate-x-0">
          <SocialFrame href={'https://warpcast.com/luminode'}>
            <FarcasterLogo /> <span className="text-white ml-[12px] text-3xl">Farcaster</span>
          </SocialFrame>
        </div>
        <div className="absolute top-[650px] md:top-[450px] xl:top-[373px] left-1/2 md:left-auto xl:left-[40px] md:right-[40px] xl:right-auto -translate-x-1/2 md:translate-x-0">
          <SocialFrame href={'https://t.me/+qgghwpWqT6piYmEx'}>
            <TelegramSocial />
          </SocialFrame>
        </div>
        <div className="absolute top-[550px] xl:top-[33px] left-1/2 md:left-[40px] xl:left-auto xl:right-[40px] -translate-x-1/2 md:translate-x-0">
          <SocialFrame href={'https://discord.gg/ThM4QSDnBY'}>
            <DiscordSocial />
          </SocialFrame>
        </div>
        <div className="absolute top-[750px] md:top-[550px] xl:top-[327px] left-1/2 md:left-auto xl:left-auto md:right-[40px] xl:right-[0px] -translate-x-1/2 md:translate-x-0">
          <SocialFrame href={'https://github.com/luminodelabs'}>
            <GithubIcon /> <span className="text-white ml-[12px] text-3xl">GitHub</span>
          </SocialFrame>
        </div>
        <div className="absolute top-[125px] left-[50%] translate-x-[-50%]">
          <div className="relative">
            <a href='https://twitter.com/LuminodeLabs' target='_blank'>
              <SocialXFrame />
            </a>
            <div className="absolute top-[140px] left-[140px] w-[204px] h-[200px]">
              <AsciiArt src={asciihand} width={204} height={200} />
            </div>
          </div>
        </div>
        <div className="absolute top-[-270px] left-[80px] z-0 pointer-events-none">
          <BigEllipse />
        </div>
        <div className="absolute top-[70px] left-[-100px] z-0 pointer-events-none">
          <DotEffect />
        </div>
        <div className="hidden xl:block absolute top-[200px] right-[740px] z-0 pointer-events-none">
          <SocialChannel1 />
        </div>
        <div className="hidden xl:block absolute top-[290px] right-[740px] z-0 pointer-events-none">
          <SocialChannel2 />
        </div>
        <div className="hidden xl:block absolute top-[130px] left-[740px] z-0 pointer-events-none">
          <SocialChannel3 />
        </div>
        <div className="hidden xl:block absolute top-[250px] left-[740px] z-0 pointer-events-none">
          <SocialChannel4 />
        </div>
      </div>
    </div>
  );
}

export default FollowUs;